import PillCouple from 'components/PillCouple/PillCouple';

export default PillCouple;
